import { useEffect, useRef, useState } from "react";

/**
 * Detects whether a `.btn-toolbar` inside the referenced container
 * has horizontal overflow (and is not scrolled to the end).
 */
export function useToolbarOverflow(deps: unknown[] = []) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [hasOverflow, setHasOverflow] = useState(false);

  useEffect(() => {
    const container = containerRef.current;
    const toolbar = container?.querySelector(".btn-toolbar");

    const checkOverflow = () => {
      if (toolbar) {
        const hasHorizontalOverflow = toolbar.scrollWidth > toolbar.clientWidth;
        const isScrolledToEnd =
          toolbar.scrollLeft + toolbar.clientWidth >= toolbar.scrollWidth - 1;
        setHasOverflow(hasHorizontalOverflow && !isScrolledToEnd);
      }
    };

    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    toolbar?.addEventListener("scroll", checkOverflow);

    return () => {
      window.removeEventListener("resize", checkOverflow);
      toolbar?.removeEventListener("scroll", checkOverflow);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { containerRef, hasOverflow };
}
